<template>
    <!-- <v-menu :content-class="note_show? 'align-menu-bottom down-arrow comment-box':' '" top offset-y offset-x -->
    <v-menu :content-class="note_show? ' ':' '" top offset-y
        :right="!$vuetify.rtl" :close-on-click="false"
        :close-on-content-click="false" :value="note_show">

        <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="instruction && instruction !== ''" v-bind="attrs" v-on="on" @click="showNoteCard" v-tooltip.hover="`${$t('res_Label_Instruction')}`"
                class="red-noti" style="width: 40px; min-width: unset !important;"><v-icon>mdi-chat</v-icon>
            </v-btn> 
            <v-btn v-else v-bind="attrs" v-on="on" @click="showNoteCard" v-tooltip.hover="`${$t('res_Label_Instruction')}`"
                style="width: 40px; min-width: unset !important"><v-icon>mdi-chat</v-icon>
            </v-btn>
        </template>

        <v-card ref="notesContainer" class=" down-arrowshadow-none p-3 py-4 rounded-4 comment-box rounded-3" style="max-width: 400px;" v-if="note_show">
            <v-toolbar class="shadow-none bg-white align-items-start p-0">
                <div class="p-0 gap-3 align-items-start d-flex">
                    <div class="user">
                        <v-avatar color="#eff2f5" size="40">{{ utils.CapitalizeFirstLetter(note_UserFullName) }}</v-avatar>
                    </div>
                    <div class="card-title">
                        <v-card-title>
                            {{ note_UserFullName }}
                        </v-card-title>
                        <p>
                            {{ note_UserPosition }}
                        </p>
                    </div>
                </div>
                <v-spacer></v-spacer>
                <v-btn @click="note_show = false" class="close-btn btn-24 light-btn" icon dark>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <p v-if="note_showFullNote == true && instruction.length > 250">
                {{ instruction }}
            </p>
            <div v-else-if="instruction && instruction != '' && note_showFullNote != true && instruction.length > 250">
                <p>
                    {{ instruction.substring(0, 250) + "..." }}
                </p>
                <a class="link-primary" style="text-decoration: none" @click="note_showFullNoteClick()">{{
                    $t("see_all_comments") }}</a>
                    
            </div>
            <p v-else-if="instruction && instruction !== ''" v-html="instruction"></p>
            <p v-else>
                {{ $t("res_Msgs_NoComments") }}
            </p>

            <p v-if="multipleTransferNotesExist" style="font-weight: bold;">{{ $t("res_Msgs_PreviousTransferNotes") }}</p>
        </v-card>
    </v-menu>
</template>

<script>
    import constants from "@/assets/js/constants.js"
    import axios from "axios"
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'TransferNotesIcon',
        props: 
        {    
            isSecretNote: false,
            toUserId: 0, 
            fromUserId: 0,
            loginUserId: 0,
            multipleTransferNotesExist: false
        },
        data() 
        {
            return {
                instruction: '',
                userId: '',
                note_show: false,
                note_showFullNote: false,
                note_UserFullName: '',
                note_UserPosition: '',
                utils: utils,
                isInTransition: false,
            }
        },
        mounted() 
        {
            this.multipleTransferNotesExist
            document.addEventListener('click', this.handleClickOutside);
        },
        beforeDestroy() 
        {
            document.removeEventListener('click', this.handleClickOutside);
        },
        watch:
        {
            userId:
            {
                handler(newVal, oldVal) { },
                immediate: true
            },
        },
        methods: {
            handleError(error) 
            {
                console.log(error)
            },
            showNoteCard() {  
                if(this.isSecretNote && this.toUserId == this.loginUserId) {
                    return this.note_show = true;
                }
                else if(!this.isSecretNote){
                    return this.note_show = true;
                }   
            },
            note_showFullNoteClick() 
            {
                var context = this;
                this.note_show = false; 
                this.note_showFullNote = true;
                this.isInTransition = true;
                setTimeout(function () { context.note_show = true; }, 0)
            },
            showTransferNotes(userId, instruction, documentId)
            {
                this.setTransferNotes(userId, instruction, true, documentId)
            },
            setTransferNotes(userId, instruction, showNoteDialog, documentId)
            {
                this.userId = userId
                this.instruction = instruction
                this.note_show = false
                this.note_showFullNote = false
                this.note_UserFullName = ''
                this.note_UserPosition = ''
                this.note_UserInstruction = ''

                if (!this.userId)
                    return

                axios.get(constants.baseApiUrl + 'User/GetTransferNoteUserInfo?userId=' + this.userId + '&documentId=' + documentId)
                    .then(response =>
                    {
                        this.note_UserFullName = utils.GetTranslatedValue(response.data.fullName, response.data.fullNameAr)
                        this.note_UserPosition = utils.GetTranslatedValue(response.data.profession, response.data.professionAr)

                        if (showNoteDialog && this.instruction && this.instruction !== '')
                            this.showNoteCard();
                    })
                    .catch(error => alert(error))
                    .finally(() => window.hideLoading())
            },
            handleClickOutside(event) 
            {
                if (this.isInTransition) 
                {
                    this.isInTransition = false;
                    return;
                }

                if (!this.$refs.notesContainer || !this.$refs.notesContainer.$el.contains(event.target)) 
                {
                    this.note_show = false;
                    this.note_showFullNote = false;
                }
            }
        }
    }
</script>
<style>
 
    @media (max-width: 567px) {
        .comment-box .v-toolbar__content {
            flex-direction: column-reverse;
        }
        .close-btn {
            align-self: end
        }
    }

</style>